(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const observeReveals = (page) => {
    const revealItems = page.querySelectorAll('[data-ec-reveal]:not([data-ec-reveal-bound])');

    if (reducedMotion.matches || !('IntersectionObserver' in window)) {
      revealItems.forEach((item) => {
        item.dataset.ecRevealBound = 'true';
        item.classList.add('is-visible');
      });
      return;
    }

    page.dataset.ecMotion = 'ready';

    const observer = new IntersectionObserver(
      (entries, instance) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          instance.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    revealItems.forEach((item) => {
      item.dataset.ecRevealBound = 'true';
      observer.observe(item);
    });
  };

  const bindFaq = (page) => {
    page.querySelectorAll('[data-ec-faq]:not([data-ec-faq-bound])').forEach((faq) => {
      faq.dataset.ecFaqBound = 'true';
      faq.addEventListener('toggle', (event) => {
        const openedItem = event.target;
        if (!(openedItem instanceof HTMLDetailsElement) || !openedItem.open) return;

        faq.querySelectorAll('details[open]').forEach((item) => {
          if (item !== openedItem) item.removeAttribute('open');
        });
      }, true);
    });
  };

  const bindMobileSticky = (page) => {
    const hero = page.querySelector('[data-ec-hero]');
    const sticky = page.querySelector('[data-ec-mobile-sticky]');
    const stickyLink = sticky?.querySelector('a');
    const mobileViewport = window.matchMedia('(max-width: 749px)');
    if (!hero || !sticky || sticky.dataset.ecStickyBound === 'true') return;

    sticky.dataset.ecStickyBound = 'true';

    const updateState = () => {
      const heroBounds = hero.getBoundingClientRect();
      const isActive = mobileViewport.matches && heroBounds.bottom < 0;

      sticky.classList.toggle('is-visible', isActive);
      sticky.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      sticky.toggleAttribute('inert', !isActive);

      if (stickyLink) {
        stickyLink.tabIndex = isActive ? 0 : -1;
      }
    };

    updateState();
    window.addEventListener('scroll', updateState, { passive: true });
    window.addEventListener('resize', updateState, { passive: true });
    mobileViewport.addEventListener?.('change', updateState);
  };

  const initializePage = (page) => {
    observeReveals(page);
    bindFaq(page);
    bindMobileSticky(page);
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('[data-ec-page]').forEach(initializePage);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  document.addEventListener('collection:reloaded', () => initializeAll());
})();
